import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  digitable: Yup.string().required('O campo Linha digitável é obrigatório'),
});

export default validationSchema;
